import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button } from 'reactstrap';
import './index.scss';
import { useSelector, useDispatch } from "react-redux";
import withReactContent from 'sweetalert2-react-content';
import { deleteOrganizationLogo } from "../../../../../context/actions/user";
import Swal from 'sweetalert2';
const MySwal = withReactContent(Swal);
const LogoPreview = () => {
	const dispatch = useDispatch();
	const logo = useSelector((state) => state?.user?.logo);
	 /**
      * @description method call delete image api
      */
	 const _delete = () => {
        MySwal.fire({
            title: 'Are you sure?',
            text: "You want to delete logo",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
            dispatch(deleteOrganizationLogo((res) => {
                }))
            }
           
        })
    }
	return (
		<div className='logo-preview position-relative d-inline-flex align-items-center justify-content-center'>
			<div className='inner'>
				<div className='icon'>
				{logo ?
                            <img className='img-fluid' src={logo} alt='Logo' />
                            : <img className="img-fluid" src={require("../../../../../assets/img/user-logo.png")} alt="Logo" />
		
                        }
					</div>
			   {logo && <Button onClick={_delete}  color='link' className='position-absolute p-0 rounded-circle'>
					<FontAwesomeIcon icon={faTimes} />
					</Button> }
			</div>
		</div>
	)
};

export default LogoPreview;